import { render, staticRenderFns } from "./MessageCode.vue?vue&type=template&id=34b3f3f4&scoped=true"
import script from "./MessageCode.vue?vue&type=script&lang=js"
export * from "./MessageCode.vue?vue&type=script&lang=js"
import style0 from "./MessageCode.vue?vue&type=style&index=0&id=34b3f3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3f3f4",
  null
  
)

export default component.exports